
import { Component, Vue } from 'vue-property-decorator'
import HeaderNav from '@/components/header-nav.vue'
import {
  notificationSecondCategoryMap,
  NotificationType
} from '@/const/notification'
import { getNotifyConfig, updateNofityConfig } from '../../service'

const subribeList = [
  [NotificationType.ISSUE_ACCOUNT, NotificationType.ISSUE_AD],
  // 本期先不开放
  // [NotificationType.TICKET]
  [NotificationType.BUSINESS_CENTER],
  [
    NotificationType.NEW_EVENT,
    NotificationType.NEW_FEATURE,
    NotificationType.PROMOTION
  ],
  [NotificationType.SUGGESTION],
  [NotificationType.REPORT]
]

@Component({
  name: 'NotificationManager',
  components: { HeaderNav }
})
export default class NotificationManager extends Vue {
  list = subribeList.map((arr) =>
    arr.map((k) => ({
      label: notificationSecondCategoryMap[k]?.label,
      id: notificationSecondCategoryMap[k]?.value,
      value: false
    }))
  )

  configMap: any = {}
  isSwitching = false

  created() {
    this.getConfig()
  }

  async getConfig() {
    try {
      const info = await getNotifyConfig()
      this.configMap = (info?.data?.subscribe_conf || []).reduce(
        (all: any, i) => {
          all[i.notification_type] = i
          return all
        },
        {}
      )
    } catch (error) {
      console.log(error)
    }
  }

  async onSwitch(
    i: { label: string; value: boolean; id: NotificationType },
    val: boolean
  ) {
    if (this.isSwitching) return
    try {
      this.isSwitching = true
      this.configMap = {
        ...this.configMap,
        [i.id]: {
          ...this.configMap[i.id],
          site_enable: val
        }
      }

      await updateNofityConfig({
        notification_type: i.id,
        site_enable: val
      })
      this.getConfig()
    } catch (error) {
      console.log(error)
    } finally {
      this.isSwitching = false
    }
  }

  onBack() {
    this.$router.back()
  }
}
